/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon24Regular = forwardRef('UiCursorAIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.008 4.861c.002-1.854 2.12-2.91 3.602-1.796l11.821 8.888c1.729 1.299.808 4.05-1.354 4.048l-5.895-.007a.75.75 0 0 0-.6.3l-3.543 4.711c-1.3 1.729-4.05.808-4.048-1.354l.017-14.79Zm2.7-.597a.75.75 0 0 0-1.2.599l-.017 14.79c-.001.72.916 1.027 1.35.451l3.542-4.712a2.25 2.25 0 0 1 1.8-.898l5.895.007c.721 0 1.028-.916.452-1.35L7.708 4.264Z" })));
});
